<template>
  <div class="priceCreatedend">
    <!-- 创建起点-公有云和数据中心 -->
    <el-dialog
      :title="diglogEnd.dialogText"
      :visible.sync="diglogEnd.centerDialogVisible"
      :width="diglogEnd.dialogStatus ? '500px' : '41%'"
      center
    >
      <div
        class="dialog"
        v-show="diglogEnd.dialogStatus"
      >
        <div
          class="tl"
          @click="cloudTap"
        >
          <div class="start">
            <img
              src="../../assets/img/price/cloudstart.png"
              alt=""
            />
          </div>
          <div>{{$t('pricedialog.cloudtitle')}}</div>
        </div>
        <div
          class="tl"
          @click="dataTap"
        >
          <div class="end">
            <img
              src="../../assets/img/price/datastart.png"
              alt=""
            />
          </div>
          <div>{{$t('pricedialog.datatitle')}}</div>
        </div>
      </div>
      <div
        class="cloud"
        v-show="diglogEnd.cloudStatus"
      >
        <el-form
          :label-position="labelPosition"
          :label-width="this.$i18n.locale=='en'?'120px':'80px'"
          :model="formLabelAlignEnd"
        >
          <el-form-item :label="$t('pricedialog.cloudtype')">
            <el-select
              v-model="formLabelAlignEnd.value"
              @change="cloudListTap(formLabelAlignEnd.value)"
              :placeholder="$t('checkvalid.select')"
            >
              <el-option
                v-for="item in optioncloud"
                :key="item.name"
                :label="$i18n.locale=='en'?item.en_name:item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div style="width:100%;display:flex; justify-content:  space-between;">
              <div class="titlehead">
                {{$t('pricedialog.country')}}
              </div>
              <div class="titlehead">
                {{$t('pricedialog.city')}}
              </div>
              <div class="titlehead">
                {{$t('pricedialog.dataheader')}}
              </div>
            </div>
            <div style="width:100%;display:flex; justify-content: space-between;">
              <ul class="widsty">
                <li
                  v-for="(item, index) in country"
                  :key="index"
                  class="country"
                  :class="item.name== select  ? 'active' :item.en_name==select?'active': ''"
                  @click="countryTap(item)"
                >
                  {{ $i18n.locale=='en'?item.en_name:item.name }}
                </li>
              </ul>
              <ul class="widsty">
                <li
                  v-for="(item, im) in city"
                  :key="im"
                  class="city"
                  :class="selectcity == item.name ? 'active' : selectcity==item.en_name?'active':''"
                  @click="cityTap(item)"
                >
                  {{ $i18n.locale=='en'?item.en_name:item.name }}
                </li>
              </ul>
              <ul class="widsty">
                <li
                  v-for="(item, ic) in poplist"
                  :key="ic"
                  class="poplist"
                  :class="selectpop == item.name ? 'active' :selectpop==item.en_name?'active' : ''"
                  @click="popTap(item)"
                >
                  <span
                    v-if="$i18n.locale=='en'"
                    :title="item.en_name"
                  >
                    {{ item.en_name | popellipsis}}
                  </span>
                  <span v-else>
                    {{ item.name}}
                  </span>
                </li>
              </ul>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="backTap">{{$t('pricedialog.back')}}</el-button>
            <el-button
              type="success"
              @click="submit"
            >{{$t('pricedialog.success')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div
        class="cloud"
        v-show="diglogEnd.dataStatus"
      >
        <el-form
          :label-position="labelPosition"
          label-width="80px"
          :model="formLabelAlignEndData"
        >
          <el-form-item>
            <div style="width:100%;display:flex; justify-content:  space-between;">
              <div class="titlehead">
                {{$t('pricedialog.country')}}
              </div>
              <div class="titlehead">
                {{$t('pricedialog.city')}}
              </div>
              <div class="titlehead">
                {{$t('pricedialog.dataheader')}}
              </div>
            </div>
            <div style="width:100%;display:flex; justify-content: space-between;">
              <ul class="widsty">
                <li
                  v-for="(item, index) in country"
                  :key="index"
                  class="country"
                  :class=" item.name== selects ? 'active' :item.en_name==selects?'active': ''"
                  @click="countryTapData(item)"
                >
                  {{ $i18n.locale=='en'?item.en_name:item.name }}
                </li>
              </ul>
              <ul class="widsty">
                <li
                  v-for="(item, im) in city"
                  :key="im"
                  class="city"
                  :class="selectcitys == item.name ? 'active':item.en_name==selectcitys?'active' : ''"
                  @click="cityTapData(item)"
                >
                  {{ $i18n.locale=='en'?item.en_name:item.name }}
                </li>
              </ul>
              <ul class="widsty">
                <li
                  v-for="(item, ic) in poplistData"
                  :key="ic"
                  class="poplist"
                  :class="selectpops == item.name ? 'active' :selectpops==item.en_name?'active' : ''"
                  @click="popTapData(item)"
                >
                <span v-if="$i18n.locale=='en'" :title="item.en_name">
                  {{ item.en_name | popellipsis}}
                </span>
                <span v-else>
                  {{item.name}}
                </span>
                </li>
              </ul>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="backTaps">{{$t('pricedialog.back')}}</el-button>
            <el-button
              type="success"
              @click="submits"
            >{{$t('pricedialog.success')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    diglogEnd: Object,
    optioncloud: Array,
    packtext: String
  },
  data() {
    return {
      formLabelAlignEnd: {
        value: "1"
      },
      optiondigEnd: [],
      // 二级
      labelPosition: "left",
      formLabelAlignEndData: {},
      allDatas: {},
      names: "",
      nation: "",
      citys: "",
      country: [], //国家
      contryid: "1",
      city: [],
      cityid: "",
      poplist: [],
      popid: "",
      poplistData: [],
      popDataid: "",
      select: "中国",
      selectcity: "",
      selectpop: "",
      selects: "中国",
      selectcitys: "",
      selectpops: ""
    };
  },
  created() {
    this.getcountry();
    this.getcity();
    this.getpop();
    this.getpopData();
  },
  methods: {
    getcountry() {
      const data = {
        token: this.$store.state.token,
        search_cloud: this.formLabelAlignEnd.value
      };
      this.$http
        .post("/price/get_country", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              this.country = res.data.data.items;
              this.select = this.$i18n.locale=='en'?"China":"中国";
              this.contryid = "1";
              this.selects = this.$i18n.locale=='en'?"China":"中国";
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getcity() {
      const data = {
        token: this.$store.state.token,
        search_country: this.contryid,
        search_cloud: this.formLabelAlignEnd.value
      };
      this.$http
        .post("/price/get_city", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.city = res.data.data.items;
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getpop() {
      const data = {
        token: this.$store.state.token,
        search_city: this.cityid,
        search_country: this.contryid,
        search_cloud: this.formLabelAlignEnd.value
      };
      this.$http
        .post("/price/get_pop", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.poplist = res.data.data.items;
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 数据中心
    getpopData() {
      const data = {
        token: this.$store.state.token,
        search_city: this.cityid,
        search_country: this.contryid,
        search_type: "dc"
      };
      this.$http
        .post("/price/get_pop", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              this.poplistData = res.data.data.items;
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    countryTap(item) {
      if(this.$i18n.locale=='en') {
        this.select =item.en_name;
      }else {
        this.select = item.name;
      }
      this.contryid = item.id;
      this.getcity();
      this.getpop();
    },
    cityTap(item) {
      if(this.$i18n.locale=='en') {
        this.selectcity=item.en_name;
      }else {
        this.selectcity = item.name;
      }
      this.cityid = item.id; //城市id
      this.getpop();
    },
    popTap(item) {
      if(this.$i18n.locale=='en') {
        this.selectpop=item.en_name;
      }else {
        this.selectpop = item.name;
      }
      this.popid = item.id;
    },
    countryTapData(item) {
      if(this.$i18n.locale=='en') {
        this.selects = item.en_name;
      }else {
        this.selects = item.name;
      }
      this.contryid = item.id;
      this.getcity();
      this.getpopData();
    },
    cityTapData(item) {
      if(this.$i18n.locale=='en') {
        this.selectcitys = item.en_name;
      }else {
        this.selectcitys = item.name;
      }
      this.cityid = item.id; //城市id
      this.getpopData();
    },
    popTapData(item) {
      if(this.$i18n.locale=='en') {
        this.selectpops = item.en_name;
      }else{
        this.selectpops = item.name;
      }
      this.popDataid = item.id;
    },
    //云端起点
    cloudTap() {
      this.diglogEnd.dialogText = this.$t("checkvalid.dialogText");
      this.diglogEnd.dialogStatus = false;
      this.diglogEnd.cloudStatus = true;
      this.select = "";
      this.selectcity = "";
      this.selectpop = "";
      this.formLabelAlignEnd.value = "1";
      this.contryid = "";
      this.cityid = "";
      this.selects = "";
      this.selectcitys = "";
      this.selectpops = "";
      // 新添加
      this.city = [];
      this.poplist = [];
      this.getcountry();
      this.getcity();
      this.getpop();
    },
    cloudListTap(value) {
      console.log(value);
      this.getcountry();
      this.getcity();
      this.getpop();
    },
    submit() {
      if (!this.cityid) {
        console.log(3333);
        this.$message({
          message: this.$t("checkvalid.selectcity"),
          type: "warning",
          duration: 1500
        });
        return;
      }
      if (!this.popid) {
        this.$message({
          message: this.$t("checkvalid.selectdata"),
          type: "warning",
          duration: 1500
        });
        return;
      }
      this.$emit(
        "end",
        JSON.stringify(this.selectpop),
        this.select,
        this.selectcity,
        this.popid,
        this.cityid,
        this.formLabelAlignEnd.value
      );
      this.diao();
      this.diglogEnd.centerDialogVisible = false;
      if (this.packtext) {
        this.$parent.tapclick();
      }
    },
    backTap() {
      this.diglogEnd.cloudStatus = false;
      this.diglogEnd.dialogStatus = true;
      this.diglogEnd.dialogText = this.$t("pricedialog.dialogTextStart");
    },
    // 数据中心
    dataTap() {
      this.diglogEnd.dialogText = this.$t("checkvalid.dc");
      this.diglogEnd.dialogStatus = false;
      this.diglogEnd.dataStatus = true;
      this.select = "";
      this.selectcity = "";
      this.selectpop = "";
      this.formLabelAlignEnd.value = "";
      this.contryid = "";
      this.cityid = "";
      this.selects = "";
      this.selectcitys = "";
      this.selectpops = "";
      // 添加
      this.city = [];
      this.poplistData = [];

      this.getcountry();
      this.getcity();
      this.getpopData();
    },
    backTaps() {
      this.diglogEnd.dialogStatus = true;
      this.diglogEnd.dataStatus = false;
      this.diglogEnd.dialogText = this.$t("pricedialog.dialogTextStart");
    },
    submits() {
      if (!this.cityid) {
        console.log(3333);
        this.$message({
          message: this.$t("pricedialog.selectcity"),
          type: "warning",
          duration: 1500
        });
        return;
      }
      if (!this.popDataid) {
        this.$message({
          message: this.$t("pricedialog.selectdata"),
          type: "warning",
          duration: 1500
        });
        return;
      }
      this.$emit(
        "end",
        JSON.stringify(this.selectpops),
        this.selects,
        this.selectcitys,
        this.popDataid,
        this.cityid
      );
      this.diao();
      this.diglogEnd.centerDialogVisible = false;
      if (this.packtext) {
        this.$parent.tapclick();
      }
    },
    diao() {
      this.$parent.datanewsmap();
    }
  }
};
</script>
<style lang="scss">
.priceCreatedend {
  .el-form--label-left .el-form-item__label {
    text-align: left;
    color: #1d5a33;
    font-size: 16px;
  }
  .el-form-item__label {
    padding: 0;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
  .el-cascader-node:not(.is-disabled):focus,
  .el-cascader-node:not(.is-disabled):hover {
    background: none !important;
  }
  .el-form-item {
    margin-bottom: 15px !important;
  }
  .el-cascader-node__postfix {
    display: none;
  }
  .widsty {
    width: 28%;
    height: 230px;
    text-align: center;
    overflow: auto;
    margin-bottom: 14px;
    border: solid 1px #1d5a33;
    border-top: 0;
    li {
      width: 100%;
      cursor: pointer;
      height: 26px;
      line-height: 26px;
    }

    .country.active {
      background: url("../../assets/img/price/select.png") no-repeat center
        center;
      background-size: 100% 100%;
      color: #fff;
    }
    .city.active {
      background: url("../../assets/img/price/select.png") no-repeat center
        center;
      background-size: 100% 100%;
      color: #fff;
    }
    .poplist.active {
      background: url("../../assets/img/price/select.png") no-repeat center
        center;
      background-size: 100% 100%;
      color: #fff;
    }
  }
}
</style>
